<template>
  <div class="features-div">
    <div class="container">
      <section class="services-section">
        <h2 v-if="homeSetting.how_work_title" class="services-title">{{ homeSetting.how_work_title }}</h2>
        <v-skeleton-loader v-else class="ms-auto my-16" type="heading" width="500"></v-skeleton-loader>

        <div class="services-grid">
          <div v-if="homeSetting.step_one_icon_url" class="service-card">
            <div class="icon">
              <img class="img-fluid" :src="homeSetting.step_one_icon_url" alt="people icon">
            </div>
            <h3>{{ homeSetting.how_work_step_one_title }}</h3>
            <p v-html="homeSetting.how_work_step_one_description"></p>
          </div>
          <v-skeleton-loader v-else class="mx-auto" type="card" width="300"></v-skeleton-loader>

          <div v-if="homeSetting.step_two_icon_url" class="service-card">
            <div class="icon">
              <img class="img-fluid" :src="homeSetting.step_two_icon_url" alt="global-search icon">
            </div>
            <h3>{{ homeSetting.how_work_step_two_title }}</h3>
            <p v-html="homeSetting.how_work_step_two_description"></p>
          </div>
          <v-skeleton-loader v-else class="mx-auto" type="card" width="300"></v-skeleton-loader>

          <div v-if="homeSetting.step_three_icon_url" class="service-card">
            <div class="icon">
              <img class="img-fluid" :src="homeSetting.step_three_icon_url" alt="message-tick icon">
            </div>
            <h3>{{ homeSetting.how_work_step_three_title }}</h3>
            <p v-html="homeSetting.how_work_step_three_description"></p>
          </div>
          <v-skeleton-loader v-else class="mx-auto" type="card" width="300"></v-skeleton-loader>

          <div v-if="homeSetting.step_four_icon_url" class="service-card">
            <div class="icon">
              <img class="img-fluid" :src="homeSetting.step_four_icon_url" alt="empty-wallet-tick icon">
            </div>
            <h3>{{ homeSetting.how_work_step_four_title }}</h3>
            <p v-html="homeSetting.how_work_step_four_description"></p>
          </div>
          <v-skeleton-loader v-else class="mx-auto" type="card" width="300"></v-skeleton-loader>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: ["homeSetting"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.services-section {
  background: url("../../../public/img/newMainPage/features-bg.png") top no-repeat, linear-gradient(145deg, #111 0%, #1b1b1b 100%);
  border-radius: 20px;
  padding: 60px 40px 180px 40px;
  text-align: center;
  margin: 60px auto;
  position: relative;
}

.services-title {
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 50px;
  line-height: 48px;
  color: #F4F4F4;
  font-style: normal;
  text-align: start;
  width: 70%;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 25px;
  justify-content: center;

  position: absolute;
  bottom: -100px;
  right: 24px;
  left: 24px;
}

@media (max-width: 768px) {
  .services-section {
    border-radius: 36px;
    padding: 16px;
    margin: 30px auto;
  }

  .services-title {
    font-size: 20px;
    margin-bottom: 24px;
    line-height: 28px;
    width: 100%;
    font-weight: 500;
  }
}

@media (max-width: 1263px) {
  .services-section {
    padding: 24px;
    margin: 30px auto;
  }

  .services-grid {
    grid-template-columns: unset;
    gap: 16px;
    align-items: center;
    justify-content: center;

    position: relative;
    bottom: unset;
    right: unset;
    left: unset;
  }
}

.service-card {
  background: #fff;
  color: #111;
  border-radius: 20px;
  padding: 30px 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.1);
}

.icon {
  background: #f2f2f2;
  color: #000;
  font-size: 28px;
  border-radius: 50%;
  width: 90px;
  height: 90px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-card h3 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
  font-style: normal;
  line-height: 28px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #1E1E1E;
}

.service-card p {
  font-size: 14px;
  color: #727272;
  text-align: right;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* ✅ Limit to 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 768px) {
  .service-card {
    border-radius: 24px;
  }

  .icon {
    font-size: 24px;
    width: 56px;
    height: 56px;
  }

  .service-card h3 {
    font-weight: 600;
  }

  .service-card p {
    line-height: 24px;
  }
}

</style>